module.exports = __webpack_public_path__ + "static/media/stucologo.1f2bd8b3.png";